import type { ValidationError } from './validation-error-types';
import { zodIssuesToValidationErrors } from './zod-to-validation-errors';

import { ownershipShema } from '../../model/schemas';

export function validateOwnership(value: unknown): ValidationError[] {
  const result = ownershipShema.safeParse(value);
  if (result.success) return [];
  return zodIssuesToValidationErrors(result.error.issues);
}
